import { EmptyState } from '@app/components/base/EmptyState';
import HistoryIcon from '@mui/icons-material/History';
import { defineMessage, FormattedMessage } from 'react-intl';

import { MIN_STREAM_FROM_LOOKBACK_MS } from '../consts';

/** Whole minutes matching {@link MIN_STREAM_FROM_LOOKBACK_MS} for the help copy. */
const minLookbackMinutes = Math.round(MIN_STREAM_FROM_LOOKBACK_MS / (60 * 1000));

const tooRecentRangeMessage = defineMessage({
  id: 'segments.listScreen.tooRecentRange',
  defaultMessage: 'El rango es demasiado reciente',
});

const tooRecentRangeHelpMessage = defineMessage({
  id: 'segments.listScreen.tooRecentRange.help',
  defaultMessage: 'Seleccione un rango de al menos {minutes} minutos anteriores al momento actual.',
});

/**
 * Empty state shown when the user has selected a range that starts within the minimum
 * lookback window (e.g. last 20 minutes). No segments are fetched in that case.
 */
export function TooRecentRangeMessage() {
  return (
    <EmptyState
      icon={HistoryIcon}
      message={<FormattedMessage {...tooRecentRangeMessage} />}
      help={
        <FormattedMessage {...tooRecentRangeHelpMessage} values={{ minutes: minLookbackMinutes }} />
      }
    />
  );
}
